<script>
  import { page } from '@inertiajs/svelte';
  import FooterMain from './Main.svelte';
  import FooterBottom from './Bottom.svelte';
  import Footer from './Index.svelte';

  export let footer;
</script>

<Footer>
  {#if !['Contacts/ThankYou', 'Error'].includes($page.component)}
    <div class="footer__bg-wrap">
      <div class="footer__bg footer__bg-visual" />
      <div class="footer__bg footer__bg-noise" />
    </div>

    <FooterMain data={footer.main} />

    <div class="container container--medium">
      <div class="line line-horizontal" />
    </div>
  {/if}

  <FooterBottom data={footer.bottom} />
</Footer>

<style lang="scss">
  :global .footer {
    &__bg {
      position: absolute;
      z-index: -1;
      inset: 0;

      &-visual {
        background: {
          image: url(img/brand-bg-el.svg);
          size: contain;
          position: center;
          repeat: no-repeat;
        }

        opacity: 0.01;
      }

      &-noise {
        background-image: url(img/noise.png);
      }
    }
  }
</style>
